import React from "react";

import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import InstagramIcon from "@material-ui/icons/Instagram";
import FacebookIcon from "@material-ui/icons/Facebook";
import TelegramIcon from "@material-ui/icons/Telegram";
import { Mail, Globe } from "lucide-react";
import { getChannelColor } from "../../constants/channels";

// Cores por canal/transporte vêm do registro canônico (constants/channels.js) —
// fonte única compartilhada com <ChannelChip> e a página de Conexões. Aqui só
// fica o mapa type -> ícone (JSX); a cor é resolvida pelo registro.
const ConnectionIcon = ({ connectionType, style }) => {
  const iconStyle = {
    marginLeft: 0,
    marginRight: 0,
    ...style,
  };
  const lucideSize = iconStyle?.fontSize || 24;

  return (
    <React.Fragment>
      {/* 🟢 WhatsApp Baileys (não oficial) */}
      {connectionType === "whatsapp" && (
        <WhatsAppIcon style={{ ...iconStyle, color: getChannelColor("whatsapp") }} />
      )}

      {/* 🔵 WhatsApp Business API (oficial Meta) */}
      {connectionType === "waba" && (
        <WhatsAppIcon style={{ ...iconStyle, color: getChannelColor("waba") }} />
      )}

      {/* 🟢 Wuzapi (whatsmeow - não oficial) */}
      {connectionType === "wuzapi" && (
        <WhatsAppIcon style={{ ...iconStyle, color: getChannelColor("wuzapi") }} />
      )}

      {/* 🐱 Whatsmeow (microserviço Go próprio) */}
      {connectionType === "whatsmeow" && (
        <WhatsAppIcon style={{ ...iconStyle, color: getChannelColor("whatsmeow") }} />
      )}

      {/* 🟣 Instagram */}
      {connectionType === "instagram" && (
        <InstagramIcon style={{ ...iconStyle, color: getChannelColor("instagram") }} />
      )}

      {/* 🔵 Facebook — azul de marca atual (#1877F2, pós-2019) */}
      {connectionType === "facebook" && (
        <FacebookIcon style={{ ...iconStyle, color: getChannelColor("facebook") }} />
      )}

      {/* ✈️ Telegram */}
      {connectionType === "telegram" && (
        <TelegramIcon style={{ ...iconStyle, color: getChannelColor("telegram") }} />
      )}

      {/* 📧 Email */}
      {connectionType === "email" && (
        <Mail style={{ ...iconStyle, color: getChannelColor("email") }} size={lucideSize} />
      )}

      {/* 🌐 Webchat */}
      {connectionType === "webchat" && (
        <Globe style={{ ...iconStyle, color: getChannelColor("webchat") }} size={lucideSize} />
      )}
    </React.Fragment>
  );
};

export default ConnectionIcon;
